import memoizeWithAllArguments from "@gef-ui/utils/memoizeWithAllArguments";
import invariant from 'invariant';
import { severity as severityConstants } from '../../constants';
import validationResolver from '../validationResolver';
export default ((validations)=>{
    const getValidationFunction = memoizeWithAllArguments((functionName, args)=>{
        const baseValidation = validations[functionName];
        invariant(baseValidation, `function ${functionName} is not found`);
        return baseValidation(args);
    });
    return ({ functionName, args = {}, severity = severityConstants.WARNING, when })=>{
        const validationFunction = getValidationFunction(functionName, args);
        return {
            severity,
            validate: validationResolver(validationFunction, {
                functionName,
                severity,
                args
            }),
            when
        };
    };
});
